/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/opk-header.js":
/*!********************************************!*\
  !*** ./src/scripts/sections/opk-header.js ***!
  \********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_header_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-header.scss */ \"./src/styles/sections/opk-header.scss\");\n\nconst breakpoint = window.matchMedia('(min-width: 990px)');\nconst mobileMenuLogic = () => {\n  const burger = document.getElementById('burger-icon');\n  const mobileDrawer = document.getElementById(\"opk-mobile-drawer\");\n  const headerWrapper = document.getElementById('opk-header-wrapper');\n  burger.addEventListener('click', () => {\n    burger.classList.toggle('active');\n    mobileDrawer.classList.toggle('active');\n    headerWrapper.classList.toggle('active');\n  });\n};\nconst breakpointChecker = function () {\n  const mobileDrawer = document.getElementById(\"opk-mobile-drawer\");\n  const burger = document.getElementById('burger-icon');\n  const headerWrapper = document.getElementById('opk-header-wrapper');\n  if (breakpoint.matches === true && mobileDrawer.classList.contains('active')) {\n    mobileDrawer.classList.remove('active');\n    burger.classList.remove('active');\n    headerWrapper.classList.remove('active');\n  }\n};\nmobileMenuLogic();\nbreakpoint.addListener(breakpointChecker);\n\n//# sourceURL=webpack://Buurman_Antwerpen/./src/scripts/sections/opk-header.js?\n}");

/***/ }),

/***/ "./src/styles/sections/opk-header.scss":
/*!*********************************************!*\
  !*** ./src/styles/sections/opk-header.scss ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://Buurman_Antwerpen/./src/styles/sections/opk-header.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-header.js");
/******/ 	
/******/ })()
;